import { NavigationCheckBusiness, NavigationCheckPrivate } from './index';
import { GlobalStateAccess } from '../../state/persistence';
import { ComponentsEnum, FlowEnum } from '../../types';

const getPrivateNavigation = () => {
  const { appStore } = GlobalStateAccess();
  if (appStore.partner) {
    return NavigationCheckPrivate.filter((item) => ![ComponentsEnum.LAND_LORD, ComponentsEnum.LEGAL].includes(item.id));
  }

  return NavigationCheckPrivate;
};

export function getNavigation() {
  const { appStore } = GlobalStateAccess();

  switch (appStore.flow) {
    case FlowEnum.CHECK_PRIVATE:
      return getPrivateNavigation();
    case FlowEnum.CHECK_BUSINESS:
      return NavigationCheckBusiness;
    default:
      return [];
  }
}

export function getPackageNavigation() {
  const { appStore } = GlobalStateAccess();

  switch (appStore.flow) {
    case FlowEnum.CHECK_PRIVATE:
      return getPrivateNavigation();
    case FlowEnum.CHECK_BUSINESS:
      return NavigationCheckBusiness;
    default:
      return [];
  }
}
